/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const CaseFeedResponse = zod
	.array(
		zod
			.object({
				title: zod.string().describe('Title'),
				actor_id: zod.string().describe('Actor ID'),
				environment_id: zod.string().describe('Environment ID'),
				id: zod.string().describe('Case ID'),
				inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
				is_violation: zod
					.boolean()
					.nullable()
					.describe('Whether the most recent trial found a violation'),
				praetor_id: zod.string().describe('Praetor ID'),
				short_id: zod.string().describe('Short ID'),
				status: zod.enum(['pending', 'completed', 'failed', 'processing']),
				thread_id: zod.string().describe('Thread ID'),
				updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
			})
			.describe('A moderation case with associated actor and content items')
	)
	.describe('List of cases');

export type CaseFeedResponse = zod.input<typeof CaseFeedResponse>;
export type CaseFeedResponseOutput = zod.output<typeof CaseFeedResponse>;
